import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { TableCell, TableRow, IconButton, Icon } from '@material-ui/core';
import moment from 'moment-timezone';
import { Link } from 'react-router-dom';

const styles = (them) => ({});

class Lead extends Component {

    render () {
        const {userData, data} = this.props;
        const {name, phone, area, date, userID, createdAt, interested, contact, _id} = data;

        return (
            <TableRow>
                <TableCell>
                    <Link to={`leads/${_id}`}>
                        <IconButton variant="fab" color="secondary" aria-label="Edit">
                            <Icon>edit_icon</Icon>
                        </IconButton>
                    </Link>
                </TableCell>
                <TableCell>
                    {createdAt && moment(createdAt).format('DD/MM/YY hh:ss')}
                </TableCell>
                <TableCell>
                    {userData ? `${userData.name} ${userData.email}` : userID}
                </TableCell>
                <TableCell>
                    {(interested !== true && interested !== false) ? 'Waiting' : interested ? 'Yes' : 'No'}
                </TableCell>
                <TableCell>
                    {contact ? 'Yes' : 'No'}
                </TableCell>
                <TableCell>
                    {name}
                </TableCell>
                <TableCell>
                    {phone}
                </TableCell>
                <TableCell>
                    {area}
                </TableCell>
                <TableCell>
                    {date && moment(date).format('DD/MM/YY')}
                </TableCell>
            </TableRow>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        users: state.userReducer,
        leads: state.leadReducer
    }
}

const LeadWithRedux = withStyles(styles)(connect(mapStateToProps)(Lead));

export {LeadWithRedux as Lead};


// WEBPACK FOOTER //
// ./src/components/LeadsPage/Lead.jsx